import SwitchWithLabel from '@glass/shared/components/muiWrappers/SwitchWithLabel';
import toRF from '@glass/shared/modules/form/toRf';

const SwitchWithLabelRf = toRF(SwitchWithLabel);

export default SwitchWithLabelRf;
